import { html, attr, TNode } from '@tempots/dom'
import {
  GoogleLoginButton,
  GitHubLoginButton,
  AuthDivider,
} from '@tempots/beatui/auth'
import { oauth } from '@/services/gateway'

export interface OAuthButtonsOptions {
  /** URL to redirect to after OAuth completes */
  redirectUrl?: string
}

/**
 * OAuth login buttons section with divider.
 * Includes Google and GitHub login buttons with "Or continue with" divider.
 */
export function OAuthButtons(
  options: OAuthButtonsOptions = {},
  ...children: TNode[]
) {
  const redirectUrl =
    options.redirectUrl ?? window.location.origin + '/dashboard'

  return html.div(
    attr.class('space-y-6'),
    // Divider - using BeatUI AuthDivider
    AuthDivider(),
    // OAuth buttons
    html.div(
      attr.class('grid grid-cols-1 gap-3'),
      GoogleLoginButton({
        onClick: async () => {
          const loginUrl = oauth.getLoginUrl('google', redirectUrl)
          window.location.href = loginUrl
        },
      }),
      GitHubLoginButton({
        onClick: async () => {
          const loginUrl = oauth.getLoginUrl('github', redirectUrl)
          window.location.href = loginUrl
        },
      })
    ),
    ...children
  )
}
